(function() {
	'use strict';
	var
		slider = tns({
			"container": '#a1-tech-carousel',
			"items": 1,
			"mode": "gallery",
			"slideBy": "page",
			"speed": 1000,
			"autoplay": true,
			"swipeAngle": false,
			"mouseDrag": false,
			"nav": true,
			"controls": false,
			"controlsContainer": ".a1-tech-carousel-controls",
			"controlsPosition": "bottom",
			"navContainer": ".a1-tech-carousel-nav",
			"navPosition": "bottom",
			onInit: function(){
				disableHiddenButtons();
				$('.a1-tech-carousel-controls').attr('tabindex', -1);
				$('.a1-tech-carousel-controls [data-controls="prev"]').attr('tabindex', 0);
				$('.a1-tech-carousel-controls [data-controls="next"]').attr('tabindex', 0);
				$('.a1-tech-carousel-nav').attr('tabindex', -1);
				$('.a1-tech-carousel-controls [data-nav]').attr('tabindex', 0);
			},
			"responsive": {
				992: {
					"controls": true
				}
			}
		});

	function disableHiddenButtons() {
		$('#a1-tech-carousel .tns-item').each(function(){
			$(this).find('.btn').attr('tabindex', -1);

			if ($(this).hasClass('tns-slide-active')) {
				$(this).find('.btn').attr('tabindex', 0);
			}
		});
	};

	// bind function to event
	slider.events.on('indexChanged', disableHiddenButtons);
})();
